// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random#getting_a_random_integer_between_two_values
function getRandomInt(min, max) {
  const minCeiled = Math.ceil(min)
  const maxFloored = Math.floor(max)
  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled) // The maximum is exclusive and the minimum is inclusive
}

export default function reconnectAfterMs(tries) {
  const nominalMs = [250, 500, 1_000, 2_500, 5_000, 10_000][tries - 1] || 15_000

  const jitterRatio = getRandomInt(75, 200) / 100
  return nominalMs * jitterRatio
}
